import {
	BackdropCircularProgress,
	DeleteConfirmationDialog,
	EnhancedDialog,
	EnhancedSnackbar,
	IResponse,
	IServerError,
	SingleColumnLayout,
	StandardPanel,
} from "@websential/cosmic-v20";
import { FormProvider, useForm } from "react-hook-form";
import { Grid, useTheme } from "@mui/material";
import {
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../common/constants";
import { Link, useNavigate, useParams } from "react-router-dom";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { formatAmountCommaSeperator, formatDate, formatDateToShow, sortDDLByLabel, useNavigateToLogout } from "../../common/Common";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { CRACreditInfoSetupFieldsPanel } from "./Panels/CRACreditInfoSetupFieldsPanel";
import { CRACreditService } from "../../services/CRACreditService";
import { CRACreditSetupToolbar } from "./CRACreditSetupToolbar";
import { CRACreditSetupValidationSchema } from "./validator";
import { DDLDataTable } from "../DDLDataTable";
import { EmployeeService } from "../../services/EmployeeService";
import { EnhancedButtonPrimeReact } from "../EnhancedButtonPrimeReact";
import { IAppState } from "../../store/reducers";
import { IDropDownListResponse } from "../../models/common/IDropDownListResponse";
import { IGetListRequest } from "../../models";
import { setSelectedDrawerOptionsMenu } from "../../store/actions/drawerMenuOptionsActions";
import { setSelectedStickyNavBar } from "../../store/actions";
import { yupResolver } from "@hookform/resolvers/yup";

// import { SingleColumnLayout } from "../EmployeeAssignemnt/SingleColumnLayout";







export interface ICRACreditSetup { }
const SINGLE_RECORD_DATA_QUERY_KEY = "craCredits-single-data-record";
const CRA_CREDIT_LIST_DATA_QUERY_KEY = "craCredits-list";

const useGetData = (
	clientId: string,
	id: string | undefined,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [SINGLE_RECORD_DATA_QUERY_KEY, clientId, id, navigateToLogout],
		queryFn: () => {
			return CRACreditService.getById(clientId, id, navigateToLogout);
		},
		refetchOnWindowFocus: false,
	});

const useCRACredit = (
	clientId: string,
	params: IGetListRequest,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [CRA_CREDIT_LIST_DATA_QUERY_KEY, params],
		queryFn: (data) => {

			return CRACreditService.getCRACredit(clientId, params, navigateToLogout);
		},
		refetchOnWindowFocus: false,
	});

const useGetPayPeriodDDL = (
	clientId: string,
	employeePayPeriodId: string | null,
	taxYear: number
) =>
	useQuery({
		queryKey: [
			"periods-ddl",
			employeePayPeriodId,
		],
		queryFn: () => {
			return CRACreditService.getPayPeriodDDL(
				clientId,
				employeePayPeriodId,
				taxYear
			);
		},
		refetchOnWindowFocus: false,
	});

const useGetPayFrequencyDDL = (clientId: string, taxYear: number) =>
	useQuery({
		queryKey: ["pay-frequency-ddl"],
		queryFn: (data) => {
			return EmployeeService.getPayFrequencyDDL(clientId, taxYear);
		},
		refetchOnWindowFocus: false,
	});

export const CRACreditSetup: React.FC<ICRACreditSetup> = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const theme = useTheme();
	const subMenuVisibility = useSelector(
		(state: IAppState) => state.drawerAction.subMenuVisibility
	);
	const clientId = useSelector((state: IAppState) => state.client.id);
	const taxYear = useSelector((state: IAppState) => state.taxYear.year);
	const navigateToLogout = useNavigateToLogout();
	const [openDialog, setDialogOpen] = useState(false);
	const [openArchiveDialog, setArchiveDialogOpen] = useState(false);
	const [singleDelete, setSingleDelete] = useState<boolean>(false);
	const [singleArchive, setSingleArchive] = useState<boolean>(false);
	const [selectedPeriod, setSelectedPeriod] = useState<string | null>(null);
	const [craCreditsId, setCRACreditId] = useState<number | string>(0);
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const queryClient = useQueryClient();
	const { id } = useParams();

	const [editRecordId, setEditRecordId] = useState(id);

	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "type",
		order_direction: "asc",
		page: 1,
		size: 25,
	});

	const onRequestParamsChange = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by:
				requestParams.sortField !== null
					? requestParams.sortField
					: "type",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};

		setQueryParams(dispatchParams);
	}, []);

	useEffect(() => {
		if (payFrequencyDDLItems) {
			const DateDDLLOad = () => {
				try {

				} catch (error) {

				}
			}
		}
	}, [])

	const { isPending, data } = useCRACredit(
		clientId,
		queryParams,
		navigateToLogout
	);

	const craCreditsList: any | null = data;


	const {
		isPending: isPendingPayPeriodDDL,
		data: payPeriodDDL,
	} = useGetPayPeriodDDL(clientId, selectedPeriod, taxYear);

	const { isPending: isPendingPayFrequencyDDL, data: payFrequencyDDLItems } =
		useGetPayFrequencyDDL(clientId, taxYear);


	// const updatedPayFrequencyDDLItems = useMemo(() => {
	// 	if (payFrequencyDDLItems) {
	// 		if (
	// 			payFrequencyDDLItems &&
	// 			Array.isArray(payFrequencyDDLItems)
	// 		) {
	// 			let resources: IDropDownListResponse[] =
	// 				payFrequencyDDLItems.map(
	// 					(resourceItem: IDropDownListResponse) => ({
	// 						// id: resourceItem.id,
	// 						label: resourceItem.label,
	// 						value: resourceItem.label,
	// 					})
	// 				);
	// 			return resources;
	// 		}
	// 		return [];
	// 	}
	// }, [payFrequencyDDLItems]);

	const { isPending: isSubmitting, mutate: submitCRACreditFormFields } =
		useMutation({
			mutationFn: CRACreditService.create,
			onSuccess: (res: any | IServerError | IResponse | any) => {

				if (res.status === 200) {
					// if (instanceOfICRACreditResponse(res)) {
					// setEditRecordId(res.id);
					// queryClient.invalidateQueries(SINGLE_RECORD_DATA_QUERY_KEY);
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
					// }
					let path = `/taxes/remittance/cra-credit/${res.data.id}`;
					navigate(path);
					return Promise.all([
						queryClient.invalidateQueries({
							queryKey: [CRA_CREDIT_LIST_DATA_QUERY_KEY],
						}),
						queryClient.invalidateQueries({
							queryKey: [SINGLE_RECORD_DATA_QUERY_KEY],
						}),
					]);
				} else if (res.status === 201) {
					// if (instanceOfICRACreditResponse(res)) {
					// setEditRecordId(res.id);
					// queryClient.invalidateQueries(SINGLE_RECORD_DATA_QUERY_KEY);
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
					// }
					let path = `/taxes/remittance/cra-credit/${res.data.id}`;
					navigate(path);
					setEditRecordId(res.data.id);
					return Promise.all([
						queryClient.invalidateQueries({
							queryKey: [CRA_CREDIT_LIST_DATA_QUERY_KEY],
						}),
						queryClient.invalidateQueries({
							queryKey: [SINGLE_RECORD_DATA_QUERY_KEY],
						}),
					]);
				} else {
					setSnackbarData({
						open: true,
						message: res.message ? res.message : "Something went wrong!",
						severity: "error",
					});
				}
			},
			onError: () => {
				// TODO: customize the toast message based on the response
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			},
		});

	const { isPending: isPendingById, data: selectedDataRecord } = useGetData(
		clientId,
		editRecordId,
		navigateToLogout
	);

	const upadtedCRACreditListItems = useMemo(() => {
		return (
			craCreditsList &&
			craCreditsList.items &&
			craCreditsList?.items.map((item: any) => ({
				...item,
				label: (
					<Link
						to={`/taxes/remittance/cra-credit/${item.id}`}
						className="no-underline"
						style={{ color: theme.palette.primary.light }}
						onClick={() => setEditRecordId(item.id)}
					>
						{item.type}
					</Link>
				),
				date: formatDateToShow(item.date),
				amount: formatAmountCommaSeperator(item.amount)
			}))
		);
	}, [craCreditsList]);


	const DEFAULT_VALUES = {
		period: undefined,
		date: undefined,
		amount: null,
	};

	const formMethods = useForm<any>({
		resolver: yupResolver(CRACreditSetupValidationSchema),
		mode: "onBlur",
		reValidateMode: "onChange",
		defaultValues: DEFAULT_VALUES
	});

	const onSubmit = (values: any) => {

		const selectedPeriod = payFrequencyDDLItems.find((x: any) => x.value === values.period)

		let payload = {
			clientId: clientId,
			id: id && id,
			navigateToLogout: navigateToLogout,
			// period: values.period,
			period: {
				label: selectedPeriod.label,
				value: selectedPeriod.value,
			},
			date: values.date,
			amount: values.amount,
		};
		submitCRACreditFormFields(payload);
	};

	useEffect(() => {
		if (id && selectedDataRecord) {

			Object.keys(selectedDataRecord).forEach((fieldName) => {
				const fieldValue = selectedDataRecord[fieldName];
				formMethods.setValue(fieldName, fieldValue ?? undefined);
				if (fieldName === "date" && payPeriodDDL) {
					formMethods.setValue("date", fieldValue);
				}
				if (fieldName === "period") {
					formMethods.setValue("period", fieldValue.value);
					setSelectedPeriod(fieldValue.value)
				}
			});
		}
	}, [id, selectedDataRecord, payPeriodDDL]);

	const onSnackbarClosed = (
		_event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	const { isPending: isDeleting, mutate: deleteCRACreditById } = useMutation({
		mutationFn: CRACreditService.delCRACredit,

		onSuccess: (res: string | IServerError | IResponse) => {
			if (typeof res === "string") {
				// remove the cache of the CRACredit fields since we just added a new field.
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
			formMethods.reset();
			let path = `/taxes/remittance/cra-credit`;
			navigate(path);
			return queryClient.invalidateQueries({
				queryKey: [CRA_CREDIT_LIST_DATA_QUERY_KEY],
			});
		},
		onError: () => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const deleteCRACreditField = () => {
		if (singleDelete) {
			setSingleDelete(false);
			let delPayload = {
				craCreditsId: craCreditsId,
				navigateToLogout: navigateToLogout,
			};
			deleteCRACreditById(delPayload);
			setDialogOpen(false);
		}
	};

	const onDeleteClicked = () => {
		setDialogOpen(true);
		setSingleDelete(true);
		if (selectedDataRecord) {
			setCRACreditId(selectedDataRecord.id);
		}
	};

	const onRowDeleteClicked = useCallback((params: any) => {
		setDialogOpen(true);
		setSingleDelete(true);
		setCRACreditId(params.id);
	}, []);

	const { isPending: isArchive, mutate: archiveCRACreditById } = useMutation({
		mutationFn: CRACreditService.archiveCRACredit,

		onSuccess: (res: string | IServerError | IResponse) => {
			if (typeof res === "string") {
				// remove the cache of the CRACredit fields since we just added a new field.
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
			formMethods.reset();
			let path = `/taxes/remittance/cra-credit`;
			navigate(path);
			return queryClient.invalidateQueries({
				queryKey: [CRA_CREDIT_LIST_DATA_QUERY_KEY],
			});
		},
		onError: () => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const archiveCRACreditField = () => {
		if (singleArchive) {
			setSingleArchive(false);
			let ArchivePayload = {
				craCreditsId: craCreditsId,
				navigateToLogout: navigateToLogout,
			};
			archiveCRACreditById(ArchivePayload);
			setArchiveDialogOpen(false);
		}
	};

	const onArchiveClicked = () => {
		setArchiveDialogOpen(true);
		setSingleArchive(true);
		if (selectedDataRecord) {
			setCRACreditId(selectedDataRecord.id);
		}
	};

	const onCloseHandler = () => {
		setDialogOpen(false);
	};
	const onCloseArchiveHandler = () => {
		setArchiveDialogOpen(false);
	};

	const onResetClicked = () => {
		setSnackbarData({
			open: true,
			message: "Success",
			severity: "success",
		});
		formMethods.reset();
		let path = `/taxes/remittance/cra-credit`;
		navigate(path);
	};

	const expandedLabels = ["Taxes", "Remittance"];
	const expandedCRACreditSetupOrSetupItem = "CRA Credit"; // Special case for "Setup" under "City Tax"
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (
				parentLabel === "Remittance" &&
				item.label === expandedCRACreditSetupOrSetupItem
			) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
				path: parentLabel === "Remittance" && item.label === expandedCRACreditSetupOrSetupItem && "/taxes/remittance/cra-credit",
			};
			return enhancedItem;
		});
	};

	useEffect(() => {
		// dispatch(
		// 	setSelectedActivityLogActions({
		// 		entityId1: "",
		// 		entityId2: "",
		// 		entityId3: "",
		// 		screenName: ACCOUNTANT_SETUP_SCREEN_SLUG,
		// 		craCreditsName: "",
		// 		activityType:
		// 			"activity_type=create&activity_type=updated&activity_type=delete",
		// 		activityLogVisibility: true,
		// 	})
		// );
		dispatch(setSelectedStickyNavBar({ isSticky: true }));
		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
	}, [drawerMenuOptions]);

	const onRowEditClicked = useCallback((params: any) => {
		// alert(`Edit row with ID: ${params.row.id} has been clicked!`);
		let path = `/taxes/remittance/cra-credit/${params.value}`;
		navigate(path);
	}, []);

	return (
		<Grid
		// sx={{
		// 	pb: "5rem",
		// 	"& .MuiAppBar-root": {
		// 		zIndex: 2,
		// 		top: subMenuVisibility ? "154px" : "112px",
		// 	},
		// }}
		>
			<BackdropCircularProgress
				open={
					isSubmitting ||
					isPendingById ||
					isDeleting ||
					isArchive ||
					isPendingPayPeriodDDL ||
					isPendingPayFrequencyDDL
				}
				testId="comapny Setup"
			/>
			<DeleteConfirmationDialog
				open={openDialog}
				deleteActionHandler={deleteCRACreditField}
				cancelActionHandler={onCloseHandler}
				testId="craCredits-confirmation-dialog"
			/>
			<FormProvider {...formMethods}>
				<form onSubmit={formMethods.handleSubmit(onSubmit)}>
					<Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
						<Grid size={{ xs: 12, sm: 12, md: 3.5, lg: 3.5, xl: 3.5 }}>
							<SingleColumnLayout
								children={
									<StandardPanel
										title="CRACredit"
										testId={`craCredits`}
										// leftSpacing={1}
										// rightSpacing={1}
										showTitle={false}
										variant="outlined"
										topPadding={2}
									>
										<CRACreditInfoSetupFieldsPanel
											dateDDL={payPeriodDDL ?? []}
											payFrequencyDDLItems={payFrequencyDDLItems && sortDDLByLabel(payFrequencyDDLItems)}
											onPeriodSelectionChangeHandler={(value: string) => setSelectedPeriod(value)}
										/>
									</StandardPanel>
								}
								toolbar={
									<CRACreditSetupToolbar
										onResetClicked={onResetClicked}
										onDeleteClicked={onDeleteClicked}
										isSubmitting={false}
										id={id}
									/>
								}
								showFullDiaplay={true}
								toolbarPosition="bottom"
								testId="form-layout"
							/>
						</Grid>
						<Grid size={{ xs: 0, sm: 0, md: 3, lg: 3, xl: 3 }}></Grid>
						<Grid
							size={{ xs: 12, sm: 12, md: 5.5, lg: 5.5, xl: 5.5 }}
							sx={{ marginTop: "16px" }}
						>
							<DDLDataTable
								rows={
									craCreditsList && upadtedCRACreditListItems
										? upadtedCRACreditListItems
										: []
								}
								columns={[
									{ field: "label", headerName: "Type" },
									{ field: "period", headerName: "Period" },
									{ field: "date", headerName: "Date" },
									{ field: "amount", headerName: "Amount" },
									{ field: "accumulate", headerName: "Accumulate" },
								]}
								showHeaderColumns={true}
								onRowEditClicked={onRowEditClicked}
								onRowDeleteClicked={onRowDeleteClicked}
								onRowArchiveClicked={onArchiveClicked}
								isLoading={isPending}
								totalRecords={
									craCreditsList && craCreditsList.total
										? craCreditsList.total
										: 0
								}
								initialPageSize={INITIAL_PAGE_SIZE}
								rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
								onRequestParamsChange={onRequestParamsChange}
								tableScrollHeight={"60vh"}
								selectedId={selectedDataRecord && id && selectedDataRecord.id}
							/>
						</Grid>
						<Grid size={{ xs: 0, sm: 0, md: 0, lg: 1, xl: 1 }}></Grid>
					</Grid>
				</form>
			</FormProvider>

			{/* Archive Dialogue */}
			<EnhancedDialog
				dialogTitle="Please Confirm"
				key="dialog-box"
				testId="dialog"
				onCloseHandler={onCloseArchiveHandler}
				open={openArchiveDialog}
				dialogContent={null}
				showdividers={false}
				dialogAction={
					<Grid>
						<EnhancedButtonPrimeReact
							label="Cancel"
							severity="secondary"
							text
							raised
							onClickHandler={onCloseArchiveHandler}
							style={{ fontSize: "small" }}
						/>
						<EnhancedButtonPrimeReact
							label="Archive"
							severity="secondary"
							raised
							onClickHandler={() => archiveCRACreditField}
							style={{ marginLeft: "16px", fontSize: "small" }}
						/>
					</Grid>
				}
			/>

			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={"craCredits-snackbar"}
				open={snackbarData.open}
			/>
		</Grid>
	);
};
